import { PeakSource } from "@/enums/enums";
import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import service from "../baseHttpService";
class BankService {
  DoGetBankReferenceList() {
    const _input = {
      merchantId: MerchantId(),
      language: i18n.locale,
      source: PeakSource.PeakPayroll,
    };

    return service.peakRealTimeAPI
      .post("/api/Finance/GetBankReferenceWithAccesToken", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetBankAccountList() {
    const _input = {
      merchantId: MerchantId(),
      language: i18n.locale,
    };
    return service.peakRealTimeAPI.post("/api/Finance/GetAllBankAccount", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetChequeDetail(chequeId: number) {
    const _input = {
      merchantId: MerchantId(),
      chequeId: chequeId,
    };
    return service.peakRealTimeAPI.post("/api/Finance/GetChequeDetail", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}
export default new BankService();
